import processHtmlAttributes from "../../common/html-attributes"

static const isBrowser = typeof window !== "undefined";

static var ignoredAttributes = [
    "sources",
    "cdnUrl",
    "cdnVersion",
    "format",
    "thumbnail",
    "playView",
    "a11yPlayText",
    "a11yLoadText",
    "a11yReportText",
    "errorText",
    "volume",
    "muted",
    "volumeSlider"
];

<div key="root" class=["video-player", !state.played && input.thumbnail !== "" && "video-player--poster"]>
    <if(isBrowser && !input.width)>
        <subscribe
            to=window
            on-resize("handleResize")/>
    </if>
    <div
        class="video-player__container"
        no-update
        style={
            width: `${input.width}px`,
            height: `${input.height}px`
        }>
        <video
            no-controls
            poster=input.thumbnail
            ...processHtmlAttributes(input, ignoredAttributes)>
            <for|src| of=(input.sources || [])>
                <source ...src/>
            </for>
            <for|track| of=(input.track || [])>
                <track ...src/>
            </for>
        </video>
    </div>
    <div class=[
        "video-player__overlay",
        !state.failed && "video-player__overlay--hidden"
    ]>
        <ebay-attention-icon/>
        <div class="video-player__overlay-text">
            <if(input.errorText)>${input.errorText}</if>
            <else>An error has occurred</else>
        </div>
    </div>
    <div
        class=[
            "video-player__overlay",
            state.isLoaded && "video-player__overlay--hidden"
        ]
        on-click("loadCDN", true)>
        <if(!state.showLoading)>
            <ebay-video-play-icon a11y-text=(input.a11yPlayText || "Click to play")/>
        </if>
        <else>
            <ebay-progress-spinner a11y-text=(input.a11yLoadText || "Loading")/>
        </else>
    </div>
</div>
